import React from 'react';
import { WifiOff, AlertTriangle } from 'lucide-react';
import { useNetworkStatus } from '../hooks/useNetworkStatus';

const OfflineBanner: React.FC = () => {
  const status = useNetworkStatus();

  if (status === 'online') return null;

  const isOffline = status === 'offline';

  return (
    <div
      className={`flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium ${
        isOffline
          ? 'bg-red-600 text-white'
          : 'bg-yellow-400 text-yellow-900'
      }`}
    >
      {isOffline ? (
        <>
          <WifiOff className="w-4 h-4" />
          <span>No internet connection</span>
        </>
      ) : (
        <>
          <AlertTriangle className="w-4 h-4" />
          <span>Unstable connection — Retrying...</span>
        </>
      )}
    </div>
  );
};

export default OfflineBanner;
